import React from 'react';
import { Card, Col, Row, Select, Slider, theme } from 'antd';
import { Area } from '@ant-design/plots';
import { Line, Column } from '@ant-design/charts';
import { ReloadOutlined } from '@ant-design/icons';
import GaugeComponent from './components/Guage';
import RangeChart from './components/RangeChart';
import RangeChart2 from './components/RangeChart2';
import TurnoverTenureChart from './components/TurnoverTenureChart';
import Logo from '../../assets/image/logo/logo.png';

const { Option } = Select;

export default function Performance() {
    const {
        token: {
            colorBgContainer,
            borderRadiusLG,
            colorWarning,
            colorPrimaryBorder,
            colorTextDescription,
            colorText,
            colorBorder,
            fontSizeSM,
            colorErrorBgHover,
            colorPrimaryBgHover,
        },
        colorPrimary,
    } = theme.useToken();

    const areaChartData = [
        { date: '2017-01-01', close: 129 },
        { date: '2017-01-11', close: 113 },
        { date: '2017-01-21', close: 122 },
        { date: '2017-01-31', close: 135 },
        { date: '2017-02-10', close: 104 },
        { date: '2017-02-20', close: 107 },
        { date: '2017-03-02', close: 108 },
        { date: '2017-03-12', close: 186 },
        { date: '2017-03-22', close: 176 },
        { date: '2017-04-01', close: 179 },
        { date: '2017-04-11', close: 159 },
        { date: '2017-04-21', close: 200 },
        { date: '2017-05-01', close: 189 },
        { date: '2017-05-11', close: 161 },
        { date: '2017-05-21', close: 131 },
        { date: '2017-05-31', close: 134 },
        { date: '2017-06-10', close: 129 },
        { date: '2017-06-20', close: 172 },
        { date: '2017-06-30', close: 138 },
        { date: '2017-07-10', close: 123 },
        { date: '2017-07-20', close: 108 },
        { date: '2017-07-30', close: 199 },
        { date: '2017-08-09', close: 135 },
        { date: '2017-08-19', close: 113 },
        { date: '2017-08-29', close: 163 },
        { date: '2017-09-08', close: 194 },
        { date: '2017-09-18', close: 105 },
        { date: '2017-09-28', close: 190 },
        { date: '2017-10-08', close: 126 },
        { date: '2017-10-18', close: 142 },
        { date: '2017-10-28', close: 183 },
        { date: '2017-11-07', close: 193 },
        { date: '2017-11-17', close: 111 },
        { date: '2017-11-27', close: 185 },
        { date: '2017-12-07', close: 129 },
        { date: '2017-12-17', close: 109 },
        { date: '2017-12-27', close: 174 },
        { date: '2018-01-06', close: 150 },
        { date: '2018-01-16', close: 102 },
        { date: '2018-01-26', close: 167 },
        { date: '2018-02-05', close: 110 },
        { date: '2018-02-15', close: 131 },
        { date: '2018-02-25', close: 128 },
        { date: '2018-03-07', close: 165 },
        { date: '2018-03-17', close: 117 },
        { date: '2018-03-27', close: 200 },
        { date: '2018-04-06', close: 123 },
        { date: '2018-04-16', close: 105 },
        { date: '2018-04-26', close: 165 },
        { date: '2018-05-06', close: 143 },
        { date: '2018-05-16', close: 170 },
        { date: '2018-05-26', close: 185 },
        { date: '2018-06-05', close: 109 },
        { date: '2018-06-15', close: 124 },
        { date: '2018-06-25', close: 187 },
        { date: '2018-07-05', close: 169 },
        { date: '2018-07-15', close: 137 },
        { date: '2018-07-25', close: 127 },
        { date: '2018-08-04', close: 138 },
        { date: '2018-08-14', close: 154 },
        { date: '2018-08-24', close: 139 },
        { date: '2018-09-03', close: 157 },
        { date: '2018-09-13', close: 105 },
        { date: '2018-09-23', close: 101 },
        { date: '2018-10-03', close: 101 },
        { date: '2018-10-13', close: 133 },
        { date: '2018-10-23', close: 181 },
        { date: '2018-11-02', close: 147 },
        { date: '2018-11-12', close: 175 },
        { date: '2018-11-22', close: 110 },
        { date: '2018-12-02', close: 199 },
        { date: '2018-12-12', close: 133 },
        { date: '2018-12-22', close: 193 },
        { date: '2019-01-01', close: 184 },
        { date: '2019-01-11', close: 186 },
        { date: '2019-01-21', close: 171 },
        { date: '2019-01-31', close: 169 },
        { date: '2019-02-10', close: 195 },
        { date: '2019-02-20', close: 188 },
        { date: '2019-03-02', close: 148 },
        { date: '2019-03-12', close: 196 },
        { date: '2019-03-22', close: 173 },
        { date: '2019-04-01', close: 130 },
        { date: '2019-04-11', close: 130 },
        { date: '2019-04-21', close: 122 },
        { date: '2019-05-01', close: 125 },
        { date: '2019-05-11', close: 182 },
        { date: '2019-05-21', close: 155 },
        { date: '2019-05-31', close: 151 },
        { date: '2019-06-10', close: 104 },
        { date: '2019-06-20', close: 198 },
        { date: '2019-06-30', close: 156 },
        { date: '2019-07-10', close: 176 },
        { date: '2019-07-20', close: 114 },
        { date: '2019-07-30', close: 166 },
        { date: '2019-08-09', close: 179 },
        { date: '2019-08-19', close: 105 },
        { date: '2019-08-29', close: 200 },
        { date: '2019-09-08', close: 174 },
        { date: '2019-09-18', close: 132 }
    ];


    const areaChartConfig = {
        data: {
            type: 'fetch',
            value: 'https://assets.antv.antgroup.com/g2/aapl.json',
        },
        xField: (d) => new Date(d.date),
        yField: 'close',
        tooltip: {
            showMarkers: true,
        },
        color: '#121212',  // line color
        areaStyle: {
            fill: 'colorPrimary',  // color of the area fill
        },
        height: 200,
        theme: "classicDark",
    };

    // Configuration for the first column plot
    const columnConfig1 = {
        theme: "classicDark",
        data: [
            { category: 'Jan', value: 30 },
            { category: 'Feb', value: 20 },
            { category: 'Mar', value: 27 },
            { category: 'Apr', value: 25 },
            { category: 'May', value: 35 },
            { category: 'Jun', value: 45 },
        ],
        xField: 'category',  // Horizontal axis labels
        yField: 'value',  // Vertical axis values
        seriesField: 'category',
        color: '#82ca9d',
        columnWidthRatio: 0.8,
        yAxis: {
            minLimit: 0,  // Start y-axis from 0
        },
        height: 200,
    };

    // Configuration for the second column plot
    const columnConfig2 = {
        theme: "classicDark",
        data: [
            { category: 'Jan', value: 15 },
            { category: 'Feb', value: 25 },
            { category: 'Mar', value: 20 },
            { category: 'Apr', value: 30 },
            { category: 'May', value: 40 },
            { category: 'Jun', value: 50 },
        ],
        xField: 'category',  // Horizontal axis labels
        yField: 'value',  // Vertical axis values
        seriesField: 'category',
        color: '#8884d8',
        columnWidthRatio: 0.8,
        yAxis: {
            minLimit: 0,  // Start y-axis from 0
        },
        height: 200,
    };

    const waterManagementData = [
        { year: '2017', type: 'Freshwater (BBL)', value: 0.1 },
        { year: '2017', type: 'Non-Freshwater (BBL)', value: 0.3 },
        { year: '2017', type: 'Produced Water (BBL)', value: 0.4 },
        { year: '2017', type: 'Water (BBL)', value: 0.5 },
        { year: '2018', type: 'Freshwater (BBL)', value: 0.1 },
        { year: '2018', type: 'Non-Freshwater (BBL)', value: 0.3 },
        { year: '2018', type: 'Produced Water (BBL)', value: 0.4 },
        { year: '2018', type: 'Water (BBL)', value: 0.5 },
        { year: '2019', type: 'Freshwater (BBL)', value: 0.2 },
        { year: '2019', type: 'Non-Freshwater (BBL)', value: 0.35 },
        { year: '2019', type: 'Produced Water (BBL)', value: 0.45 },
        { year: '2019', type: 'Water (BBL)', value: 0.55 },
        { year: '2020', type: 'Freshwater (BBL)', value: 0.15 },
        { year: '2020', type: 'Non-Freshwater (BBL)', value: 0.32 },
        { year: '2020', type: 'Produced Water (BBL)', value: 0.42 },
        { year: '2020', type: 'Water (BBL)', value: 0.52 },
        { year: '2021', type: 'Freshwater (BBL)', value: 0.2 },
        { year: '2021', type: 'Non-Freshwater (BBL)', value: 0.4 },
        { year: '2021', type: 'Produced Water (BBL)', value: 0.45 },
        { year: '2021', type: 'Water (BBL)', value: 0.55 },
    ];

    const waterManagementConfig = {
        theme: "classicDark",
        data: waterManagementData,
        isStack: true,
        xField: 'year',
        yField: 'value',
        seriesField: 'type',
        height: 200,
        color: ['#1890ff', '#f04864', '#facc14'],  // Only three colors needed for three types
    };

    const wasteManagementData = [
        { year: '2017', type: 'Total Hazardous Waste', value: 650 },
        { year: '2017', type: 'Total Non-Hazardous Waste', value: 620 },
        { year: '2017', type: 'Total Waste Diverted', value: 610 },
        { year: '2018', type: 'Total Hazardous Waste', value: 630 },
        { year: '2018', type: 'Total Non-Hazardous Waste', value: 600 },
        { year: '2018', type: 'Total Waste Diverted', value: 590 },
        { year: '2019', type: 'Total Hazardous Waste', value: 610 },
        { year: '2019', type: 'Total Non-Hazardous Waste', value: 600 },
        { year: '2019', type: 'Total Waste Diverted', value: 580 },
        { year: '2020', type: 'Total Hazardous Waste', value: 520 },
        { year: '2020', type: 'Total Non-Hazardous Waste', value: 500 },
        { year: '2020', type: 'Total Waste Diverted', value: 480 },
        { year: '2021', type: 'Total Hazardous Waste', value: 480 },
        { year: '2021', type: 'Total Non-Hazardous Waste', value: 450 },
        { year: '2021', type: 'Total Waste Diverted', value: 420 },
    ];

    const wasteManagementConfig = {
        theme: "classicDark",
        height: 200,
        data: wasteManagementData,
        isStack: true,
        xField: 'year',
        yField: 'value',
        seriesField: 'type',
        color: ['#1890ff', '#2f54eb', '#1d39c4'], // Adjust colors as needed to match image
    };
    


    return (
        <>
            <Row gutter={16}>
                <Col span={6}>
                    <Card bordered={false} style={{ height: 269 }} size='small'>
                    <center>
            <img src={Logo}/>
            </center>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontWeight: 'bold', color: colorText }}>2016-12-15</span>
                            <span style={{ fontWeight: 'bold', color: colorText }}>2024-12-15</span>
                        </div>
                        <Slider defaultValue={30} />

                        {/* Date Filter */}
                        <div style={{ marginTop: '16px' }}>
                            <span style={{ fontWeight: 'bold', marginRight: '8px', color: colorText }}>Date</span>
                            <Select defaultValue="All" style={{ width: '100%' }}>
                                <Option value="all">All</Option>
                                <Option value="today">Today</Option>
                                <Option value="thisWeek">This Week</Option>
                                <Option value="thisMonth">This Month</Option>
                            </Select>
                        </div>

                        {/* Area Filter */}
                        <div style={{ marginTop: '16px' }}>
                            <span style={{ fontWeight: 'bold', marginRight: '8px', color: colorText }}>Area</span>
                            <Select defaultValue="All" style={{ width: '100%' }}>
                                <Option value="all">All</Option>
                                <Option value="area1">Area 1</Option>
                                <Option value="area2">Area 2</Option>
                                <Option value="area3">Area 3</Option>
                            </Select>
                        </div>
                    </Card>
                </Col>
                <Col span={10}>
                    <Card bordered={false} style={{ maxHeight: 269 }} title="Scope 1 Day by Day" size='small'>
                        <Area {...areaChartConfig} />
                    </Card>
                </Col>
                <Col span={4}>
                    <Card bordered={false} style={{ maxHeight: 269 }} title="TRIR" size='small'>
                        <Column {...columnConfig1} />
                    </Card>
                </Col>
                <Col span={4}>
                    <Card bordered={false} style={{ maxHeight: 269 }} title="LTIR" size='small'>
                        <Column {...columnConfig2} />
                    </Card>
                </Col>
            </Row>
            <br />
            <Row gutter={16}>
                <Col span={6}>
                    <Card bordered={false} size="small" title="Emission Intensity">
                        <GaugeComponent value={17.5} min={0} max={100} size={200} />
                    </Card>
                    <br/>
                    <Card bordered={false}  size="small" title="Emission Intensity">
                        <GaugeComponent value={17.5} min={0} max={100} size={200} />
                    </Card>
                    <br/>
                    <Card bordered={false}  size="small" title="Emission Intensity">
                        <GaugeComponent value={17.5} min={0} max={100} size={200} />
                    </Card>                    
                </Col>
                <Col span={10}>
                    <Card bordered={false} style={{ maxHeight: 269 }} title="Scope 2 Day by Day" size='small'>
                        <Area {...areaChartConfig} />
                    </Card>
                    <br/>
                    <Card bordered={false} style={{ maxHeight: 269 }} title="Scope 2 Day by Day" size='small'>
                        <TurnoverTenureChart />
                    </Card>
                </Col>
                <Col span={4}>
                    <Card bordered={false} style={{ maxHeight: 269 }} title="Water Management" size='small'>
                        <Column {...waterManagementConfig} />
                    </Card>
                    <br/>
                    <Card bordered={false} style={{ maxHeight: 269 }} title="Emition by Volatile" size='small'>
                        <RangeChart />
                    </Card>
                </Col>
                <Col span={4}>
                    <Card bordered={false} style={{ maxHeight: 269 }} title="Waste Management" size='small'>
                        <Column {...wasteManagementConfig} />
                    </Card>
                    <br/>
                    <Card bordered={false} style={{ maxHeight: 269 }} title="Emition by Volatile" size='small'>
                        <RangeChart2 />
                    </Card>
                </Col>
            </Row>
        </>
    );
}
